import React, {useContext} from "react";
import {Button, Card, Form, Input, message, Typography} from 'antd';
import {AuthContext} from "../context/AuthContext";
import {useHttp} from "../hooks/http.hook";
import {tokens} from "../components/ui/tokens";

const LoginPage = () => {
    const {loading, request} = useHttp({def: {}})
    const auth = useContext(AuthContext)

    const loginHandler = async (form) => {
        try {
            const data = await request('/api/auth/login', 'POST', {...form})
            auth.login(data.token, data.userId, data.userType, data.user, data.cubeToken)
        } catch (e) {}
    }

    const onFinish = (values) => {
        loginHandler(values).then(() => {})
    };

    return (
        <div style={{
            minHeight: '80vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
        }}>
            <Card bordered={false}
                  style={{width: '100%', maxWidth: 400, borderRadius: tokens.radius, boxShadow: tokens.shadow}}
                  bodyStyle={{padding: 28}}>
                <div style={{display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20}}>
                    <span style={{
                        width: 34, height: 34, borderRadius: 11, color: '#fff',
                        background: `linear-gradient(135deg, ${tokens.primary}, ${tokens.accent})`,
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        fontWeight: 700, fontSize: 14,
                    }}>DT</span>
                    <div>
                        <Typography.Title level={4} style={{margin: 0, fontWeight: 600}}>Digital Twin</Typography.Title>
                        <Typography.Text type={"secondary"} style={{fontSize: 12}}>
                            Моделирование онкологической помощи
                        </Typography.Text>
                    </div>
                </div>

                <Form name="basic" layout={"vertical"} initialValues={{remember: true}}
                      onFinish={onFinish} autoComplete="off" requiredMark={false}>
                    <Form.Item label="Имя пользователя" name="username"
                               rules={[{required: true, message: 'Введите имя пользователя'}]}>
                        <Input size={"large"} autoFocus/>
                    </Form.Item>

                    <Form.Item label="Пароль" name="password"
                               rules={[{required: true, message: 'Введите пароль'}]}>
                        <Input.Password size={"large"}/>
                    </Form.Item>

                    <Form.Item style={{marginBottom: 12}}>
                        <Button type="primary" htmlType="submit" size={"large"} block loading={loading}>
                            Войти
                        </Button>
                    </Form.Item>

                    <Form.Item style={{marginBottom: 0}}>
                        <Button size={"large"} block onClick={() => message.error('Нет подключения к ЕСИА')}>
                            Войти через Госуслуги
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default LoginPage
